<template>
    <div>
      <div class="bgc_white">
        <NavbarHeader activeName="culture"></NavbarHeader>
        <div v-if="bannerList.length>0" style="background-color: #F5F5F5;">
          <swiperList v-if="bannerList.length>0" :bannerList="bannerList"></swiperList>
        </div>
        <div class="gflex flexcolumn recommend_section">
          <div class="menu_text2">
            <headerTitle englishText="CULTURAL CONCE"
            positiveTitle="文化理念" subheading="哥弟商元，四海哥弟，“将”心选之"></headerTitle>
          </div>
          <div class="culture_wrap ideabg1">
            <img class="culture_innerbgimg" :src="require('../../assets/image/ideaone.png')" />
            <div class="culture_inner flexjccenter flexcolumn">
              <div class="culture_text">
                <div class="ideafont1">我们的使命</div>
                <div class="ideafont2">Our mission</div>
              </div>
              <p class="ideafont3">致力于家居生活，家居服饰、家居家纺、个人护理、家清卫浴、健康养生等一系列，多元化的精品。</p>
              <p class="ideafont4">Committed to home life, home clothing, home textilespersonalcare,
                home Qing bathroom, health and a series of diversified products.</p>
            </div>
          </div>
          <div class="culture_wrap ideabg2">
            <img class="culture_innerbgimg" :src="require('../../assets/image/ideatwo.png')" />
            <div class="culture_inner flexjccenter flexcolumn">
              <div class="culture_text">
                <div class="ideafont1">我们的愿景</div>
                <div class="ideafont2">Our  vision</div>
              </div>
              <p class="ideafont3">我们用了40年时间让您穿的美丽得体，愿再用40年时间让您活的美好精致。</p>
              <p class="ideafont4">We have spent 40 years to make you wear beautiful anddecent
                and would like to spend another 40 years to make you  live
                beautiful and delicate.</p>
            </div>
          </div>
          <div class="culture_wrap ideabg3">
            <img class="culture_innerbgimg" :src="require('../../assets/image/ideathree.png')" />
            <div class="culture_inner flexjccenter flexcolumn">
              <div class="ideafont1">我们的价值观</div>
              <div class="ideafont2">Our  valuse</div>
              <p class="ideafont3">凡人，平等互重，将心比心，<br/>凡事，共存共享，相依相惜。</p>
              <p class="ideafont4">Mortals, equal, mutual respect  Everything, coexistence and
                  sharing, depend on  each  other.</p>
            </div>
          </div>
        </div>
        <div class="business_title">
          <headerTitle englishText="HEALTH CULTURAL"
          positiveTitle="健康文化" subheading="随时随地深呼吸"></headerTitle>
        </div>
        <div class="business_section">
          <div class="business_wrap">
            <div class="business_left1">
              <el-image class="business_img" :src="require('../../assets/image/breathing.png')" fit="cover"></el-image>
            </div>
            <div class="business_innerwrap">
              <div class="breathing_title">随时随地深呼吸</div>
              <p>推己及人</p>
              <p>深呼吸 随时随地养成习惯将常保高血氧的体质 也就是拥有强大的免疫力</p>
              <p>当前要认知</p>
              <p>血氧含量达 95 以上是不可能感染病毒的，血氧越高，免疫力越强大</p>
              <p>今全世界每天至少 20 亿的口罩量，其无法降解，对环保影响巨大</p>
              <p>深呼吸从我做起告而广之广而告之</p>
              <p>四海之内皆兄弟</p>
              <p>加油深呼吸</p>
            </div>
          </div>
          <div class="business_left2">
            <el-image class="business_img" :src="require('../../assets/image/breathing.png')" fit="cover"></el-image>
          </div>
        </div>
        <div class="gflex flexcolumn recommend_section" v-if="activityList.length>0">
          <div class="menu_text3">
            <headerTitle englishText="CULTURAL ACTIVITY"
            positiveTitle="文化活动" subheading="我们凝聚在一起"></headerTitle>
          </div>
          <div class="product_categray">
            <div class="categray_wrap">
              <ul class="flex categray_ul" :style="[{marginLeft: cateLeft+'px'}]">
                <li v-for="(item, index) in activityList" :key="index">
                    <template v-if="item.mediaType=='mp4'">
                      <div class="bigVideo">
                        <video :src="item.picUrl"
                          height="228" width="360" preloader="auto" controls>
                          <p>你的浏览器不支持video标签</p>
                        </video>
                      </div>
                      <div class="smallVideo">
                        <video :src="item.picUrl"
                          height="185" width="315" preloader="auto" controls>
                          <p>你的浏览器不支持video标签</p>
                        </video>
                        <div class="trademark_name">{{item.eventName}}</div>
                      </div>
                    </template>
                    <div class="trademark_menu" v-else>
                      <div class="trademark_smallimg">
                        <el-image
                           style="width: 360px; height: 228px"
                           :src="item.picUrl"
                           :preview-src-list="srcList">
                        </el-image>
                      </div>

                      <img class="trademark_img" :src="item.picUrl" />

                      <div class="trademark_phoneimg">
                        <el-image
                           style="width: 315px; height: 185px"
                           :src="item.picUrl"
                           :preview-src-list="srcList">
                        </el-image>
                      </div>
                      <div class="trademark_name">{{item.eventName}}</div>
                    </div>
                </li>
              </ul>
            </div>
            <div class="categray_arrow categray_arrow_left flexcenter flexcolumn">
              <img src="../../assets/image/arrow_left.png" @click="fnPrev()" />
            </div>
            <div class="categray_arrow categray_arrow_right flexcenter flexcolumn">
              <img src="../../assets/image/arrow_right.png" @click="fnNext()" />
            </div>
          </div>
        </div>
        <footerBar></footerBar>
      </div>
    </div>
</template>
<script>
	import { basebannerListapi, companyeventbaseapi
	} from "@/api/apilist/commonApi";
  import headerTitle from "@/components/assembly/headerTitle.vue";
  import swiperList from "@/components/assembly/swiperList.vue";
  import footerBar from "@/components/footerBar/footerBar.vue";
  import NavbarHeader from "@/components/NavbarHeader/NavbarHeader.vue";
  export default {
      components: {
        NavbarHeader, footerBar, swiperList, headerTitle
      },
      data() {
        return {
          bathUrl: 'https://mall.alicdn.girdeargroup.com/admin/pms/media/images/',
          bannerList: [],
          cultureideaList: [{url: '../../assets/image/ideaone.png'},
            {url: '../../assets/image/ideatwo.png'},
            {url: '../../assets/image/ideathree.png'},
          ],
          activityList: [],
          srcList: [],
          cateCurrent: 0,
          cateLeft: 0,
          cateTotalwidth: 0,
          showarrowLeft: false,
          showarrowRight: true,
        };
      },

      created() {
		this.getbasebannerList();
		this.getcompanyeventbase();
      },
      methods:{
        picUrlclick(item){
          window.open(item.picUrl, "_blank");
        },
        getbasebannerList() {
          basebannerListapi({ bannerType: 3 }).then(res=>{
            this.bannerList = res.data;
          })
        },
        getcompanyeventbase() {
          companyeventbaseapi().then(res=>{
            res.data.forEach((item)=>{
              if(item.picUrl.indexOf('.mp4')==-1){
                this.srcList.push(item.picUrl);
                item.mediaType = 'img';
              }
              if(item.picUrl.indexOf('.mp4')!==-1){
                item.mediaType = 'mp4';
              }
            })
            this.activityList = res.data;
          })
        },
        fnPrev(){
          if(this.cateLeft>= -375){
            this.cateLeft = 0;
            this.cateTotalwidth = 0;
          }else{
            this.cateLeft = this.cateLeft + 375;
          }
        },
        fnNext(){
          let mylength = this.activityList.length - 3;
          if(this.cateTotalwidth<mylength){
            this.cateTotalwidth +=1;
            this.cateLeft = this.cateLeft-375;
          }
        },
      }
  }
</script>

<style scoped lang="less">
  @media screen and (max-width: 480px){
    .recommend_section{
      width: 100%;
    }
    .bigVideo{display: none;width: 360px;}
    .menu_text2{ margin: 52px auto 27px; }
    .menu_text3{ margin: 25px auto 25px; }
    .culture_wrap{
      width: 100%;
      padding: 0 15px;
      margin-bottom: 10px;
      .culture_innerbgimg{
        width: 100%;
      }
      .culture_inner{
        margin: 10px 0;
        .culture_text{display: flex;align-items: flex-end;}
        .ideafont1{
          font-size: 18px;
          font-weight: bold;
        }
        .ideafont2{font-size: 12px;color: #989898;margin-left: 5px;}
        .ideafont3{font-size: 16px;margin-top: 10px;line-height: 25px;}
        .ideafont4{font-size: 14px;margin-top: 15px;color: #989898;line-height: 20px;}
      }
    }
    .business_title{margin: 35px auto 27px;}
    .business_section{
      padding: 0 15px 25px;
      background-color: #fff;
      .business_left1{width: 100%;}
      .business_left2{display: none;}
      .business_img{display: block;}
      .breathing_title{display: none;}
      .business_innerwrap{
        width: 75%;
        margin: 10px auto 0;
        p{font-size: 14px;line-height: 35px;text-align: center;}
      }
    }
    .product_categray{
      width: 100%;
      height: 215px;
      overflow-y: hidden;
      font-size: 18px;
      text-align: center;
      position: relative;
      margin-bottom: 50px;
      .categray_arrow{
        display: none;
        width: 33px;height: 100%;background-color: #FFFFFF;position: absolute;
        img{width: 27px;height: 50px;cursor: pointer;}
      }
      .categray_arrow_left{left: 0;}
      .categray_arrow_right{right: 0;}
      .categray_wrap{
        width: 375px;
        overflow-x: scroll;
        white-space: nowrap;
        position: absolute;
        padding-bottom: 10px;
        left: 0px;
        top: 0;
        right: 0;
        margin: 0 auto;
        .categray_ul{
          transition: 0.3s;
          li{
            cursor: pointer;
            display: block;
            margin: 0 7px;
            .trademark_menu{
              width: 315px;
              .trademark_smallimg{display: none;}
              .trademark_phoneimg{
                width: 315px;
                height: 185px;
                border-radius: 4px;
                overflow: hidden;
              }
              .trademark_img{
                width: 315px;
                height: 185px;
                display: none;
              }
              .trademark_name{
                text-align: center;
                margin-top: 5px;
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
  @media screen and (min-width: 481px){
    .recommend_section{
      width: 1200px;
      margin: 0 auto;
    }
    .smallVideo{display: none;width: 315px;}
    .trademark_name{display: none;}
    .menu_text2{ margin: 111px auto 47px; }
    .menu_text3{ margin: 50px auto 45px; }
    .ideabg1{background-image: url(../../assets/image/ideaone.png);}
    .ideabg2{background-image: url(../../assets/image/ideatwo.png);}
    .ideabg3{background-image: url(../../assets/image/ideathree.png);}
    .culture_wrap{
      width: 100%;
      height: 476px;
      margin-bottom: 50px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .culture_innerbgimg{display: none;}
      .culture_inner{
        width: 600px;
        height: 376px;
        background-color: rgba(251, 251, 251, 0.6);
        margin-top: 50px;
        padding-left: 46px;
        padding-right: 42px;
        .ideafont1{
          font-size: 27px;
          font-weight: bold;
        }
        .ideafont2{font-size: 16px;}
        .ideafont3{font-size: 16px;margin-top: 50px;line-height: 30px;}
        .ideafont4{font-size: 16px;margin-top: 30px;line-height: 30px;}
      }
    }
    .business_title{display: none;}
    .business_section{
      background-color: #F2F2F2;
      height: auto;
      display: flex;
      align-items: stretch;
      min-width: 1200px;
	  margin-bottom: 50px;
      .business_left1{display: none;}
      .business_left2{flex: 1;}
      .business_img{display: block;}
      .business_wrap{
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
        .breathing_title{font-size: 24px;font-weight: bold;margin-bottom: 15px;}
        .business_innerwrap{
          width: 600px;
          padding-right: 32px;
          height: 73%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          p{font-size: 16px;}
        }
      }
    }
    .product_categray{
      width: 100%;
      height: 232px;
      overflow: hidden;
      font-size: 18px;
      text-align: center;
      position: relative;
      margin-bottom: 110px;
      .categray_arrow{
        width: 33px;height: 100%;background-color: #FFFFFF;position: absolute;
        img{width: 27px;height: 50px;cursor: pointer;}
      }
      .categray_arrow_left{left: 0;}
      .categray_arrow_right{right: 0;}
      .categray_wrap{
        width: 1122px;
        overflow-x: scroll;
        white-space: nowrap;
        position: absolute;
        padding-bottom: 20px;
        left: 41px;
        // height: 240px;
        top: 0;
        .categray_ul{
          transition: 0.3s;
          li{
            cursor: pointer;
            display: block;
            line-height: 40px;
            margin: 0 7px;
            .trademark_menu{
              width: 360px;
              height: 230px;
              overflow: hidden;
              border-radius: 10px;
              text-align: center;
              position: relative;
              cursor: pointer;
              display: block;
              .trademark_img{
                width: 360px;
                height: 230px;
              }
              .trademark_phoneimg{display: none;}
              .trademark_smallimg{
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 3;
                opacity: 0;
              }
              .trademark_name{
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 2;
                color: #fff;
                font-size: 24px;
                font-weight: bold;
                line-height: 230px;
                background-color: rgba(0,0,0,0.5);
                display: none;
              }
            }
            .trademark_menu:hover .trademark_name{display: block;}
          }
        }
      }
    }
  }



  .recommend_section{
    margin: 0 auto;
    background-color: #fff;
  }
  .menu_text4{
    margin: 91px auto 50px;
  }

  @media screen and (min-width: 1451px){
      .business_innerwrap p{
        font-size: 18px;
      }
  }

</style>
